import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSubscriptionInfo } from '../../actions/checkout-subscription-actions';
import { selectPowerSubscriptionId } from '../../utils/subscriptionUtils';

// Resolves the member's Power subscription id for the shared Update-Credit-Card modal when a caller
// (e.g. the bookmark / Resume flow) can't provide one (TMS-2338 deliverable 7). auth.user carries no
// subscription id, so the id comes from the subscription list: reuse the already-loaded
// state.subscribe.subscriptions, and only fetch getSubscriptionInfo when that list is empty — never
// re-fetch an already-populated one.
const usePowerSubscriptionId = (providedSubscriptionId) => {
    const dispatch = useDispatch();
    const subscriptions = useSelector(({ subscribe }) => subscribe?.subscriptions);
    const [isResolving, setIsResolving] = useState(false);
    // A caller-supplied id wins, so a fetch must never fire for it. Guards against a second fetch when
    // the list is still empty after a request already resolved (e.g. a member with no Power sub).
    const hasRequestedRef = useRef(false);

    const hasProvidedId = providedSubscriptionId !== undefined &&
        providedSubscriptionId !== null &&
        providedSubscriptionId !== '';

    useEffect(() => {
        if (hasProvidedId || hasRequestedRef.current) {
            return;
        }
        if (selectPowerSubscriptionId(subscriptions) !== null) {
            return;
        }
        hasRequestedRef.current = true;
        setIsResolving(true);
        Promise.resolve(dispatch(getSubscriptionInfo()))
            .finally(() => { setIsResolving(false); });
    }, [hasProvidedId, subscriptions, dispatch]);

    if (hasProvidedId) {
        return { subscriptionId: providedSubscriptionId, isResolving: false };
    }

    const resolvedId = selectPowerSubscriptionId(subscriptions);
    return { subscriptionId: resolvedId, isResolving: isResolving && resolvedId === null };
};

export default usePowerSubscriptionId;
